var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserAccount = function SvgUserAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#B0C9E2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M4 24c0-7.542 0-11.314 2.343-13.657S12.458 8 20 8h8c7.542 0 11.314 0 13.657 2.343S44 16.458 44 24s0 11.314-2.343 13.657S35.542 40 28 40h-8c-7.542 0-11.314 0-13.657-2.343S4 31.542 4 24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#B0C9E2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M22 20a4 4 0 1 0-8 0 4 4 0 0 0 8 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#B0C9E2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M26 32a8 8 0 0 0-16 0M30 18h8M30 24h8"
  })));
};
export default SvgUserAccount;